import React from 'react';
import Icon from '../app_components/Icon';
import { semantic } from '@lexody/design-tokens';
import { usesDashFormVariant } from '../../utils/formVariant';

function Search(props) {
  const { value, placeholder, onChange, variant } = props;

  if (usesDashFormVariant(variant)) {
    return (
      <div className="lex-dash-field lex-dash-field--teal">
        <div className="lex-dash-field__inputWrap">
          <input
            className="lex-dash-field__input"
            value={value}
            placeholder={placeholder}
            onChange={(event) => onChange(event.target.value)}
          />
          <span className="lex-dash-field__icon" aria-hidden="true">
            <Icon name="search" size={16} color={semantic.success.surface.default} solid />
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="searchContainer" style={{ display: 'flex' }}>
      <input
        className="searchInput"
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
}

export default Search;
